import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cheapesturbaniarentalservice() {



    const cardData =
    {
        keyword: 'Cheapest Urbania Rental Service in Pune',
        heading: 'Urbania on rent in pune: Cheapest Urbania Rental Service in Pune',
        headingDescription: 'Urbania On Rent in Pune offers the cheapest Urbania rental service in Pune without compromising on comfort, safety, or reliability for group travel across the city and nearby destinations. Our well-maintained Force Urbania fleet delivers spacious seating, air-conditioned comfort, and smooth performance, making it ideal for local travel, corporate commutes, airport transfers, family outings, weddings, and outstation journeys at budget-friendly rates. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from all major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a cost-effective and stress-free travel experience. Backed by 24/7 booking support, punctual service, and transparent pricing, Urbania On Rent in Pune stands out as the trusted choice for the cheapest and most dependable Urbania rental service in Pune.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic historical fort and a powerful symbol of Maratha pride. Once the administrative center of Bajirao I, it features massive stone walls, majestic gates like the Delhi Darwaza, and spacious courtyards. Although a major fire destroyed much of the structure, the remaining fort reflects royal grandeur. The evening light-and-sound show narrates Maratha history, making it a must-visit heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is one of Pune’s most important landmarks connected to India’s freedom struggle. Built in 1892, it served as a prison for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during the Quit India Movement. The palace now houses a museum displaying Gandhi’s personal belongings, photographs, and letters. Its Italian-style arches, lush lawns, and peaceful environment make it both historically significant and visually stunning."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous and revered Ganesh temple. The idol is richly adorned with gold ornaments and attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the heart of Pune’s grand celebrations with processions and cultural programs. The temple trust is also well known for its social and charitable initiatives, making it spiritually and socially significant."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a historic hill fortress located amidst the Sahyadri ranges and is famous for the legendary battle fought by Tanaji Malusare. The fort offers panoramic views of Pune city, ancient bastions, memorials, and scenic trekking routes. Visitors enjoy traditional Maharashtrian food like pithla-bhakri at the top. It is a perfect destination combining history, adventure, and natural beauty."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. It features monolithic pillars, a circular Nandi mandap, and ancient carvings reflecting early Indian craftsmanship. Despite being located in a busy area, the temple maintains a calm and spiritual ambiance, offering a peaceful retreat within the city."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected from across India, showcasing traditional art, musical instruments, sculptures, and household items. One of its highlights is the recreated Mastani Mahal. The museum offers deep insight into India’s cultural heritage and is a treasure trove for history lovers, students, and art enthusiasts."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks and offers breathtaking panoramic views after climbing 103 stone steps. The hilltop Parvati Temple, built during the Peshwa era, is dedicated to Lord Shiva and Goddess Parvati. The complex also includes smaller shrines and a museum. Sunrise and sunset views from the hill are especially captivating."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a globally renowned center for meditation, mindfulness, and wellness. Surrounded by lush gardens, it attracts visitors from around the world seeking peace, relaxation, and self-discovery. The serene atmosphere and unique meditation techniques make it a distinctive spiritual destination in Pune."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped garden. It features flowing water streams, stone bridges, manicured lawns, and seasonal flowers. The garden offers a peaceful environment for walks, photography, and family outings, beautifully blending Japanese aesthetics with Indian natural beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular picnic and leisure spot near Pune. The expansive water body, surrounding hills, and cool breezes create a scenic setting, especially during monsoon and evenings. Local vendors selling corn and tea add to its charm. It also serves as the gateway to Sinhagad Fort, making it a favorite weekend getaway."
  }
],



"services": [
    {
      "name": "Cheapest Urbania Rental Service in Pune",
      "description": "Cheapest Urbania Rental Service in Pune offers highly affordable transportation solutions for families, groups, and corporate clients. The service focuses on delivering clean, well-maintained Urbania vehicles with professional chauffeurs while keeping rental costs low and transparent for local and outstation travel."
    },
    {
      "name": "Low Cost Urbania Hire Pune",
      "description": "Low Cost Urbania Hire Pune provides budget-friendly Urbania rentals designed for cost-conscious travelers. Ideal for group travel, office trips, and family outings, the service ensures reliable vehicles, trained drivers, and comfortable seating at economical prices."
    },
    {
      "name": "Budget Urbania Rental Pune",
      "description": "Budget Urbania Rental Pune delivers dependable Urbania vehicles at competitive rates without compromising safety or comfort. Suitable for short trips, group travel, and daily requirements, the service balances affordability with quality transportation."
    },
    {
      "name": "Affordable Urbania on Rent Pune",
      "description": "Affordable Urbania on Rent Pune offers cost-effective rental options for customers seeking comfortable group transportation. With transparent pricing, well-maintained vehicles, and professional chauffeurs, it ensures a smooth and economical travel experience."
    },
    {
      "name": "Cheap Urbania Bus Hire Pune",
      "description": "Cheap Urbania Bus Hire Pune provides spacious buses at economical rates for group travel, picnics, and local tours. Designed for affordability, the service ensures safe travel with experienced drivers and reliable vehicle performance."
    },
    {
      "name": "Urbania Rental at Best Price Pune",
      "description": "Urbania Rental at Best Price Pune focuses on offering maximum value through competitive pricing and quality service. Customers benefit from comfortable vehicles, punctual chauffeurs, and flexible rental options at the most reasonable rates."
    },
    {
      "name": "Economy Urbania Hire Pune",
      "description": "Economy Urbania Hire Pune is ideal for travelers seeking cost-effective Urbania rentals for local and outstation journeys. With clean vehicles, professional drivers, and budget-friendly pricing, it ensures reliable transportation at lower costs."
    },
    {
      "name": "Urbania AC Bus at Low Price Pune",
      "description": "Urbania AC Bus at Low Price Pune offers air-conditioned buses at affordable rates for group travel and corporate needs. This service combines comfort, climate control, and professional chauffeur service while maintaining economical pricing."
    },
    {
      "name": "Corporate Budget Urbania Pune",
      "description": "Corporate Budget Urbania Pune provides affordable transportation solutions for companies managing employee travel and business events. With contract-based pricing, reliable vehicles, and professional drivers, it ensures cost efficiency for corporate clients."
    },
    {
      "name": "Cheapest Outstation Urbania Pune",
      "description": "Cheapest Outstation Urbania Pune delivers low-cost options for long-distance and intercity travel. Ideal for family tours, pilgrimages, and group outings, it offers highway-ready vehicles, experienced drivers, and transparent outstation pricing."
    },
    {
      "name": "Value for Money Urbania Pune",
      "description": "Value for Money Urbania Pune emphasizes balanced pricing with dependable service quality. Customers receive comfortable seating, professional chauffeur support, and well-maintained vehicles that deliver excellent value for every rupee spent."
    },
    {
      "name": "Best Price Urbania Rental Pune",
      "description": "Best Price Urbania Rental Pune ensures customers receive competitive rates backed by reliable service. Suitable for families, corporate teams, and group travelers, it combines affordability, comfort, and professional transportation."
    },
    {
      "name": "Trusted Cheap Urbania Service Pune",
      "description": "Trusted Cheap Urbania Service Pune focuses on delivering affordable rentals while maintaining high standards of safety and reliability. With verified drivers and clean vehicles, customers can enjoy budget travel with peace of mind."
    },
    {
      "name": "Cost Effective Urbania Hire Pune",
      "description": "Cost Effective Urbania Hire Pune offers economical Urbania rentals tailored to different travel needs. Whether for local trips, outstation journeys, or group events, the service ensures efficient transportation at reasonable costs."
    },
    {
      "name": "Discounted Urbania Rental Pune",
      "description": "Discounted Urbania Rental Pune provides special pricing and seasonal offers for customers seeking affordable Urbania services. With maintained vehicles, flexible packages, and professional chauffeurs, it delivers quality travel at reduced prices."
    }
  ],
  "tableData": [
    ["Cheapest Urbania Rental Service in Pune", "Low Cost Urbania Hire Pune"],
    ["Budget Urbania Rental Pune", "Affordable Urbania on Rent Pune"],
    ["Cheap Urbania Bus Hire Pune", "Urbania Rental at Best Price Pune"],
    ["Economy Urbania Hire Pune", "Urbania AC Bus at Low Price Pune"],
    ["Corporate Budget Urbania Pune", "Cheapest Outstation Urbania Pune"],
    ["Value for Money Urbania Pune", "Best Price Urbania Rental Pune"],
    ["Trusted Cheap Urbania Service Pune", "Cost Effective Urbania Hire Pune"],
    ["Discounted Urbania Rental Pune", ""]
  ],



"whychoose": [
    {
        "WhyChooseheading": "Affordable Cheapest Urbania Rental Service in Pune",
        "WhyChoosedescription": "Cheapest Urbania Rental Service in Pune offers budget-friendly and comfortable group travel options for families, corporate outings, and outstation trips."
    },
    {
        "WhyChooseheading": "Spacious and Well-Maintained Force Urbania Vehicles",
        "WhyChoosedescription": "Cheapest Urbania Rental Service in Pune provides well-maintained Force Urbania vehicles that are clean, spacious, and ideal for long and short trips without breaking the budget."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Cheapest Urbania Rental Service in Pune includes experienced drivers who know Pune city and surrounding routes well, ensuring safe, timely, and hassle-free travel."
    },
    {
        "WhyChooseheading": "Transparent and Competitive Pricing",
        "WhyChoosedescription": "Choose Cheapest Urbania Rental Service in Pune for transparent pricing with no hidden charges, making group travel reliable and affordable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Cheapest Urbania Rental Service in Pune offers round-the-clock booking assistance and customer support for all your travel needs."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Cheapest Urbania Rental Service in Pune is available for hourly trips, full-day bookings, local city travel, wedding transfers, and outstation journeys."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Safe Vehicles",
        "WhyChoosedescription": "All vehicles under the Cheapest Urbania Rental Service in Pune are regularly cleaned, sanitized, and maintained for passenger comfort and safety."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Cheapest Urbania Rental Service in Pune ensures on-time pickups and dependable service for stress-free group travel experiences."
    }
]
}

const faqData = [
    {
        question: 'Is Cheapest Urbania Rental Service in Pune suitable for both local and outstation travel?',
        answer: 'Yes, Cheapest Urbania Rental Service in Pune can be booked for local city travel as well as outstation trips with affordable pricing.',
    },
    {
        question: 'How can I book Cheapest Urbania Rental Service in Pune?',
        answer: 'You can book Cheapest Urbania Rental Service in Pune via phone, WhatsApp, or online booking for quick and hassle-free reservations.',
    },
    {
        question: 'Why should I choose Cheapest Urbania Rental Service in Pune?',
        answer: 'Cheapest Urbania Rental Service in Pune offers spacious seating, comfortable interiors, professional drivers, and the lowest prices in the city.',
    },
    {
        question: 'Are drivers experienced with Cheapest Urbania Rental Service in Pune?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in providing comfortable and safe travel.',
    },
    {
        question: 'Can I customize pickup and drop-off locations?',
        answer: 'Absolutely. Cheapest Urbania Rental Service in Pune allows flexible pickup and drop-off locations across Pune and nearby areas.',
    },
    {
        question: 'Is Cheapest Urbania Rental Service in Pune available 24x7?',
        answer: 'Yes, Cheapest Urbania Rental Service in Pune operates 24x7 to meet your travel needs any time of the day or night.',
    },
    {
        question: 'Are vehicles sanitized regularly?',
        answer: 'Yes, all vehicles are cleaned and sanitized regularly to ensure a safe and hygienic travel experience.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Cheapest Urbania Rental Service in Pune accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey to ensure a smooth and stress-free experience.',
    },
    {
        question: 'Can Cheapest Urbania Rental Service in Pune be booked for weddings and events?',
        answer: 'Yes, Cheapest Urbania Rental Service in Pune can be booked for weddings, events, corporate travel, and other special occasions.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rohan Deshpande',
        feedback: 'We chose Cheapest Urbania Rental Service in Pune for our family outing. The pricing was great and the service was smooth and comfortable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Ananya Kulkarni',
        feedback: 'Cheapest Urbania Rental Service in Pune provided excellent service at a very affordable rate. Highly recommended!',
        rating: 5,
    },
];








































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cheapest Urbania Rental Service in Pune",
  "image": "https://urbaniaonrentpune.in/assets/images/cheapest-urbania-rental-pune.jpg",
  "description": "Cheapest Urbania Rental Service in Pune offers budget-friendly AC and non-AC Urbania buses for city travel, corporate trips, family outings, and outstation journeys. Chauffeur-driven buses provide safe, comfortable, and convenient transportation at the most affordable rates in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/cheapest-urbania-rental-service-pune"
  }
};






    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Cheapest Urbania Rental Service in Pune | Budget AC & Non-AC Urbania Hire 
  </title>

  <meta
    name="description"
    content="Book the Cheapest Urbania Rental Service in Pune for city travel, corporate trips, family outings, and outstation journeys. AC and non-AC Urbania buses with chauffeur-driven service provide safe, comfortable, and convenient transportation at affordable rates in Pune."
  />

  <meta
    name="keywords"
    content="Cheapest Urbania Rental Service in Pune, Low Cost Urbania Hire Pune, Budget Urbania Rental Pune, Affordable Urbania on Rent Pune, Cheap Urbania Bus Hire Pune, Urbania Rental at Best Price Pune, Economy Urbania Hire Pune, Urbania AC Bus at Low Price Pune, Corporate Budget Urbania Pune, Cheapest Outstation Urbania Pune, Value for Money Urbania Pune, Best Price Urbania Rental Pune, Trusted Cheap Urbania Service Pune, Cost Effective Urbania Hire Pune, Discounted Urbania Rental Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/96.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cheapesturbaniarentalservice;